import { LocationOn, Menu as MenuIcon } from '@mui/icons-material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import React, { useContext, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import { getUrlPath } from '../../global/getUrl';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DiscountIcon from '@mui/icons-material/Discount';
import './StoreHeaderMobile.scss';
import variables from '../../global/assets/_variables.scss';
import { SwipeableDrawer } from '@mui/material';
import { StoreHeaderDataContext } from '../../context-api/StoreHeaderDataProvider';
import ZipCodeForm from '../../atomic/zipcodechecker/web/zipcodeform/ZipCodeForm';
import AtomicButton from '../../atomic/button/AtomicButton';
import { CheckoutDataContext } from '../../context-api/CheckoutDataProvider';
import DeliveryTimeSlotPicker from '../deliveryTimeSlotPicker/DeliveryTimeSlotPicker';
import AddDeliveryAddress from '../deliveryaddress/AddDeliveryAddress';
import { DeliveryAddressDataContext } from '../../context-api/DeliveryAddressDataProvider';
import { localStorageKeys } from '../../global/constants';
import GlobalPromoCodes from '../globalPromoCodes/GlobalPromoCodes';
import USER_SVG_GREY from '../../global/assets/svg/UserGrey.svg';
import USER_SVG from '../../global/assets/svg/UserOrange.svg';

const buttonStyleProp = {
  width: 'fit-content',
  height: '40px',
  padding: '6px',
  fontSize: '12px',
  lineHeight: 'initial',
  fontSize: '12px',
  textTransform: 'none',
  width: 130,
  flexGrow: 1,
  flexShrink: 1,
};
const zipCodeFormContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: '20px',
};
const inputStyles = {
  height: '40px',
  flexGrow: 1,
  flexShrink: 1,
  background: 'white',
};
function StoreHeaderMobile() {
  const { ZIP_CODE } = localStorageKeys;
  const { getDeliveryAddressListResponse } = useContext(DeliveryAddressDataContext);
  const { kitchensByZipcode } = useContext(StoreHeaderDataContext) || {};
  let { data, loading, success, zipcode } = kitchensByZipcode;
  const { isLoggedIn } = useContext(LoginDataContext);
  const { payAsYouGoPayloadForCheckout } = useContext(CheckoutDataContext);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openPromoDrawer, setOpenPromoDrawer] = useState(false);

  const drawerContainerRef = useRef();
  const navigate = useNavigate();
  const checkUrlPathCheckout = getUrlPath() === '/checkoutorder';
  const IsStoreMenuPage = getUrlPath().includes('/onthemenu/storemenu');
  const IsUpSalePage = getUrlPath().includes('/upsaleproducts');
  const IsCreateMealAccount = getUrlPath().includes('/createmealaccount');
  const IsSignup = getUrlPath().includes('/signup');
  const IsPricing = getUrlPath().includes('/pricing');
  const IsLogin = getUrlPath().includes('/login');
  const IsForgotPassword = getUrlPath().includes('/forgotpassword');
  const IsCustomerAccount = getUrlPath().includes('/customeraccount');

  const IsNextDayMealPage = getUrlPath().includes('/nextdaypromotionmeal');
  const KitchenNameToRedirect = payAsYouGoPayloadForCheckout?.kitchen_name;
  const NoAddressFound = getDeliveryAddressListResponse?.errorMessage === 'User donst not exist';

  const UrlPathCheck = ['/pricing'].some((path) => getUrlPath().includes(path));

  zipcode = localStorage.getItem(ZIP_CODE);

  const handleClickRedirect = async () => {
    // setStoreAccountType(setStoreTyp);
    // setStoreName(urlStoreName);
    // setProductsData({});
    if (KitchenNameToRedirect) {
      navigate(`/onthemenu/storemenu?storename=${KitchenNameToRedirect}`);
    } else {
      navigate(`/onthemenu`);
    }
  };

  const path = '/onthemenu/storemenu';
  const isExact = path === getUrlPath() || path.startsWith('/onthemenu/storemenu/pdp?');
  const RedirectToBackPage = () => {
    if (isExact) {
      navigate('/onthemenu');
    } else {
      navigate(-1);
    }
  };

  if (checkUrlPathCheckout) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'start',
          alignItems: 'center',
          height: '50px',
          position: 'fixed',
          zIndex: 1000,
          top: '0',
          padding: '0px 0px 0px 18px',
          width: '100vw',
          backgroundColor: '#ffffff',
          borderBottom: '1px solid black',
        }}
      >
        <div style={{ fontSize: '20px', fontFamily: 'roboto Bold', color: '#FF7A28' }}>
          {' '}
          Checkout{' '}
        </div>{' '}
        &nbsp;&nbsp;&nbsp;
        <AtomicButton
          label={KitchenNameToRedirect ? KitchenNameToRedirect : 'Continue shopping'}
          style={{
            height: '30px',
            width: '220px',
            backgroundColor: '#F2F2F2',
            margin: '10px',
            // position: 'fixed',
            bootom: '0',
            fontFamily: 'roboto regular',
            fontSize: '12px',
            color: '#181436',
            textTransform: 'capitalize',
          }}
          handleSubmit={handleClickRedirect}
          endIcon={''}
          startIcon={<ArrowBackIcon sx={{ color: '#181436', fontSize: '20px' }} />}
        />
      </div>
    );
  }

  if (!checkUrlPathCheckout) {
    return (
      <div className='sub-header-mobile'>
        {(IsStoreMenuPage ||
          IsUpSalePage ||
          IsNextDayMealPage ||
          IsCreateMealAccount ||
          IsSignup ||
          IsPricing ||
          IsLogin ||
          IsForgotPassword) && (
          <ArrowBackIosIcon
            fontSize='medium'
            sx={{
              color: IsPricing ? 'White' : 'rgb(24, 20, 54)',
              margin: '5.5px 0px 5.5px 5.5px',
              cursor: 'pointer',
            }}
            onClick={RedirectToBackPage}
          ></ArrowBackIosIcon>
        )}

        <div className='flex-row'>
          <LocationOn
            style={{ fill: variables.activeFontOrange, marginLeft: '0px', marginRight: '5px' }}
          ></LocationOn>
          <div
            className='styled-div flex-row'
            onClick={() => {
              setOpenDrawer(true);
            }}
          >
            {!zipcode ? (
              <span className={`flex-column ${UrlPathCheck ? 'white' : ''}`}>
                Enter US Zip code
              </span>
            ) : (
              <div className={`flex-column ${UrlPathCheck ? 'white' : ''}`}>
                {`Delivery to - ${zipcode}`}
              </div>
            )}
          </div>
        </div>

        {!IsStoreMenuPage && (
          <DiscountIcon
            fontSize='small'
            sx={{
              color: UrlPathCheck ? 'white' : '#181436',
              marginRight: '10px',
              margin: '7px',
              marginLeft: 'auto',
              cursor: 'pointer',
            }}
            onClick={() => {
              setOpenPromoDrawer(true);
            }}
          />
        )}

        <SwipeableDrawer
          anchor='bottom'
          open={openDrawer || openPromoDrawer}
          onClose={() => {
            setOpenDrawer(false);
            setOpenPromoDrawer(false);
          }}
          className='drawer-mobile-style'
          onOpen={() => {
            setOpenDrawer(false);
            setOpenPromoDrawer(false);
          }}
          swipeAreaWidth={56}
          disableSwipeToOpen={false}
          ModalProps={{
            keepMounted: true,
          }}
          style={{ zIndex: 100012, height: '700px' }}
          container={drawerContainerRef.current}
        >
          {(NoAddressFound || !isLoggedIn) && openPromoDrawer === false && (
            <ZipCodeForm
              buttonStyleProp={buttonStyleProp}
              zipCodeFormContainerStyle={zipCodeFormContainerStyle}
              buttonBackground={variables.backgroundDarkBlue}
              inputStyles={inputStyles}
              data={data}
              loading={loading}
              success={success}
              buttonLabel='Find Food'
            />
          )}

          {isLoggedIn && !NoAddressFound && openPromoDrawer === false && <AddDeliveryAddress />}

          {openPromoDrawer && <GlobalPromoCodes />}

          <div style={{ height: '40px', color: 'white' }}>keeping space for footer</div>
        </SwipeableDrawer>

        {/* {(isLoggedIn && !IsStoreMenuPage) && <MenuIcon style={{ fill: '#707070', margin: '5px', marginLeft: 'auto' }} />} */}

        {IsStoreMenuPage && (
          <div
            style={{
              margin: '0px 5px 5px 5px',
              marginLeft: 'auto',
            }}
          >
            <DeliveryTimeSlotPicker />
          </div>
        )}

        <img
          style={{ margin: '0px 5px 5px 5px', cursor: 'pointer' }}
          width='22px'
          src={IsCustomerAccount ? USER_SVG : USER_SVG_GREY}
          alt=''
          onClick={() => {
            navigate('/customeraccount');
          }}
        />
      </div>
    );
  }
}

export default StoreHeaderMobile;
